import { Bucket, SearchResponse } from '@cinch-nx/data-search'
import {
  ComponentMap,
  SbBlokData,
  storyblokImageLoader,
} from '@cinch-nx/data-storyblok'
import { StoryblokRendererV2 } from '@cinch-nx/storyblok-utils'
import cx from 'classnames'
import React from 'react'

import { homeStoryFallback } from '../../data/fallback/homepage-props-fallback'
import { Makes } from '../../types/vehicles-data'
import { HeroCard } from './hero-card'
import { HeroCarousel } from './hero-carousel'
import { HeroTabs } from './hero-tabs'
import styles from './hero.module.css'

export interface HeroBlockProps {
  isHeroPromotional: boolean
  heroPartExchange: {
    title: string
    label: string
    placeholder: string
    ctaText: string
    partExTextList: {
      text: string
    }[]
  }[]
  rightSideContent: SbBlokData[]
}

export interface HeroAdditionalProps {
  heroFormAdditionalData: {
    totalStock: number
    makes: Makes[]
    priceBucket: Bucket
    monthlyPriceBucket: Bucket
    shouldProdAdobeTargetTestRun?: boolean
    searchResponse?: SearchResponse
  }
  storyFallback?: boolean
}

export interface HeroProps extends HeroBlockProps, HeroAdditionalProps {}

const heroComponents: ComponentMap = {
  HomeHeroCard: HeroCard,
  LoopingCarousel: HeroCarousel,
}

const HomeHeroV2: React.FC<HeroProps> = (props) => {
  const {
    isHeroPromotional,
    heroPartExchange,
    heroFormAdditionalData,
    rightSideContent,
    storyFallback,
  } = props
  const { title, ctaText, label, placeholder, partExTextList } =
    heroPartExchange[0]

  const heroPartExTextList = partExTextList.map((item) => item.text)

  return (
    <section className={styles['container']} aria-describedby="hero-heading">
      <div
        className={cx(styles['background'], styles['backgroundGradient'], {
          [styles['backgroundGradientForPromo']]: isHeroPromotional,
        })}
      >
        <div className={styles['heroInner']}>
          <div className={styles.rightSideContainer}>
            <StoryblokRendererV2
              block={
                rightSideContent ??
                (homeStoryFallback.content.herov2?.[0]
                  ?.rightSideContent as SbBlokData[])
              }
              props={{
                ...(!storyFallback
                  ? { imageLoader: storyblokImageLoader }
                  : {}),
              }}
              components={heroComponents}
            />
          </div>

          <HeroTabs
            title={title}
            ctaText={ctaText}
            label={label}
            placeholder={placeholder}
            partExTextList={heroPartExTextList}
            {...heroFormAdditionalData}
          />
        </div>
      </div>
    </section>
  )
}

export default HomeHeroV2
